
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

import ChooseAccount from './chooseAccount.vue'

import type { XTUCPhone4JOptions, XTUCPhone4JMemberOptions } from '@xt/client/entities/user/controller'

type BindPhoneKey = '1'

type BindEmailKey = '2'

type ActiceKey = BindPhoneKey | BindEmailKey

@Observer
@Component({
  components: {
    ChooseAccount
  }
})
export default class BindDeviceLogin extends Vue {
  // 选择账号
  memberAccount: Array<XTUCPhone4JMemberOptions> = []

  phoneKey: BindPhoneKey = '1'

  emailKey: BindEmailKey = '2'

  tabPane: Array<{ key: ActiceKey; title: string }> = [
    { key: this.phoneKey, title: '手机绑定' },
    { key: this.emailKey, title: '邮箱绑定' }
  ]

  activeKey: ActiceKey = this.phoneKey

  get UserStore() {
    return this.$store.$storeUser
  }

  // 绑定账号的过程触发了选择账号逻辑
  get isChooseAccount() {
    return this.memberAccount.length > 0
  }

  get formOptions() {
    return {
      isWhiteList: true,
      phone: this.activeKey === this.phoneKey,
      codeType: this.activeKey === this.phoneKey ? 10 : 11,
      label: this.activeKey === this.phoneKey ? '手机号' : '邮箱',
      btnText: '绑定'
    }
  }

  handleChangeTab(activeKey: ActiceKey) {
    this.activeKey = activeKey
  }

  handleBack() {
    this.memberAccount = []
  }

  async onSubmit(model: XTUCPhone4JOptions & { verifyCode: string }) {
    console.warn(',pde', model, JSON.stringify(model))

    if (model.result === true) {
      // 绑定成功直接登录
      await this.UserStore.onLogin({ tempToken: model.tempToken, code: model.verifyCode }, 'wx_applets2')

      this.$msg('登录成功，欢迎你桐学 🎉')
      setTimeout(() => {
        window.location.reload()
      }, 50)
    } else if (Array.isArray(model.memberLoginVOS) && model.memberLoginVOS.length > 0) {
      // 账号冲突 需要用户手动选择登录哪个账号
      this.memberAccount = model.memberLoginVOS
    }
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
